import { useIsMutating } from '@tanstack/react-query';
import React from 'react';
import styled from 'styled-components';
import { SocialProvider, useSocialSignInMutation } from '../hooks/mutations';
import { Colors } from '../patterns/Colors';
import { /* GithubIcon, */ GoogleIcon, MicrosoftIcon /* , SlackIcon */ } from './SocialIcons';

export type { SocialProvider };

const SOCIAL: { id: SocialProvider, label: string, icon: React.ReactNode }[] = [
    { id: 'google', label: 'Continue with Google', icon: <GoogleIcon /> },
    // { id: 'github', label: 'Continue with GitHub', icon: <GithubIcon /> },
    // { id: 'slack', label: 'Continue with Slack', icon: <SlackIcon /> },
    { id: 'microsoft', label: 'Continue with Microsoft', icon: <MicrosoftIcon /> },
];

interface Props {
    callbackURL?: string;
    disabled?: boolean;
}

export const SocialLoginView = ({ callbackURL, disabled }: Props) => {

    const inFlight = useIsMutating() > 0 || !!disabled;
    const socialMutation = useSocialSignInMutation(callbackURL);
    const busy = socialMutation.isPending ? socialMutation.variables ?? null : null;

    return <>
        <SocialGrid>
            {SOCIAL.map(({ id, label, icon }) => (
                <SocialButton
                    key={id}
                    type="button"
                    onClick={() => socialMutation.mutate(id)}
                    disabled={inFlight}
                    $busy={busy === id}
                >
                    <SocialIcon>{icon}</SocialIcon>
                    <span>{label}</span>
                </SocialButton>
            ))}
        </SocialGrid>
        {socialMutation.error && <ErrorText>{socialMutation.error.message}</ErrorText>}
    </>;
};

const SocialGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: 1.25rem;

    @media (min-width: 1152px) {
        grid-template-columns: 1fr 1fr;
    }
`;

const SocialButton = styled.button<{ $busy: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0.875rem;
    background: white;
    border: 1px solid ${Colors.border};
    border-radius: 0.375rem;
    font-size: 0.875rem;
    color: ${Colors.text};
    cursor: pointer;
    text-align: left;
    transition: background 0.1s;

    &:hover:not(:disabled) {
        background: ${Colors.borderLight};
    }

    &:disabled {
        opacity: ${p => p.$busy ? 1 : 0.5};
        cursor: not-allowed;
    }
`;

const SocialIcon = styled.span`
    display: inline-flex;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
`;

const ErrorText = styled.p`
    font-size: 0.8125rem;
    color: #b91c1c;
    margin: 0.5rem 0 0;
`;
